(() => {
  const SELECTOR = '[data-embe-blog-swiper]';

  function initOne(el) {
    if (el.dataset.embeInit === '1') return;
    el.dataset.embeInit = '1';

    if (!window.Swiper) {
      // Retry when Swiper is loaded (theme uses defer).
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (window.Swiper) {
          clearInterval(timer);
          el.dataset.embeInit = '0';
          initOne(el);
          return;
        }
        if (tries >= 30) clearInterval(timer);
      }, 100);
      return;
    }

    const prev = el.querySelector('.swiper-button-prev');
    const next = el.querySelector('.swiper-button-next');
    const pagination = el.querySelector('.swiper-pagination');

    const opts = {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      roundLengths: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        540: { slidesPerView: 2, spaceBetween: 24 },
        1200: { slidesPerView: 3, spaceBetween: 24 }
      }
    };

    if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
    if (pagination) opts.pagination = { el: pagination, clickable: true };

    try {
      // eslint-disable-next-line no-new
      new window.Swiper(el, opts);
    } catch (e) {
      // keep static layout if Swiper fails
      el.classList.add('embe-swiper-failed');
    }
  }

  function init(root = document) {
    root.querySelectorAll?.(SELECTOR)?.forEach?.(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

